import { registerEntityEndpoint as e } from "@editor/ui-utils";
var t = e("reusable-text"), { getEntity: n, listEntities: r, putEntity: i, postEntity: a, deleteEntity: o } = t, s = async (e) => n(e), c = async (e) => a(e), l = async (e) => {
	let { _id: t, ...n } = e;
	return i(t, n);
}, u = async (e) => o(e), d = () => ({
	title: "",
	brand: "bunte",
	textContent: "<p></p>",
	hasAffiliate: !1,
	textboxType: "DEFAULT",
	legacy: {
		source: "vibe",
		isEditableInCTF: !0,
		hasBeenModifiedInCTF: !0,
		isRenderedByCTF: !0
	}
});
//#endregion
export { c as a, s as i, u as n, l as o, d as r, t };

//# sourceMappingURL=reusable-text.service-BRwTtG_l.js.map